import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { WishlistHeaderComponent } from '../../components/wishlist-header/wishlist-header';
import { WishlistComponent } from '../../components/wishlist/wishlist';
import { SortAndFilterBarComponent } from '../../components/sort-and-filter-bar/sort-and-filter-bar';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NavBarComponent } from '../../components/nav-bar/nav-bar';


/**
 * Generated class for the WishlistPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-wishlist',
  templateUrl: 'wishlist.html',
  styleUrls: ['./wishlist.scss'],
  standalone: false,
  imports: [
    IonicModule,
    WishlistHeaderComponent,
    WishlistComponent,
    SortAndFilterBarComponent,
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule,
//    NavBarComponent
  ]
})
export class WishlistPage {
  public static PATH: string = 'wishlist';

  constructor() {
  }

}
